import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onSuccess"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQueryClient, useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import useSearchParams from 'hooks/useSearchParams';
import { setAlert, setSuccessAlert } from 'actions/alerts';
import { contentQueryKeys } from 'actions/content';
import { playlistQueryKeys } from '.';
function useDuplicatePlaylists(_ref) {
  var _onSuccess = _ref.onSuccess,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  function duplicatePlaylists(_x) {
    return _duplicatePlaylists.apply(this, arguments);
  }
  function _duplicatePlaylists() {
    _duplicatePlaylists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var playlistIds;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            playlistIds = _ref2.playlistIds;
            return _context.abrupt("return", api('post', '/api/playlists/duplicate', null, {
              playlistIds: playlistIds,
              withIndex: true,
              selectedTopicId: searchParams.topicId
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _duplicatePlaylists.apply(this, arguments);
  }
  var _useMutation = useMutation(duplicatePlaylists, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess(data, variables) {
        setSuccessAlert({
          title: t('alert_duplicate_playlist_success', {
            count: variables.playlistIds.length
          })
        });
        return Promise.all([queryClient.invalidateQueries(contentQueryKeys.contentLogs()), queryClient.invalidateQueries(playlistQueryKeys.playlistList())]).then(function () {
          return _onSuccess === null || _onSuccess === void 0 ? void 0 : _onSuccess(data);
        });
      },
      onError: function onError(data, variables) {
        setAlert({
          title: t('alert_duplicate_playlist_error', {
            count: variables.playlistIds.length
          })
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    duplicatePlaylists: mutateAsync
  });
}
export default useDuplicatePlaylists;